// extracted by mini-css-extract-plugin
module.exports = {"ggoInlineIcon":"ggo-improve-icon_ggoInlineIcon__EYDON"};